import React from "react";
import "./tabbar.css";
import logo from '../../assets/images/logo1.jpeg'
import logo2 from "../../assets/images/conferenceImg.png"

const Tabbar = ({ toggleDarkMode, toggleSidebar, darkMode }) => {
  return (
    <nav className="tabbar">
      <h1 className="tabbar-image"><img src={logo} alt="" /></h1>
      <h3 className="main-date">23 to 26-April-2025</h3>
      <h1 className="tabbar-image"><img src={logo2} alt="" /></h1>
    </nav>
  );
};

export default Tabbar;
